import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal, SectionHeading } from "./Reveal";

export default function Faq({ content }) {
  const c = content?.faq;
  return (
    <section id="faq" className="bg-cream-deep py-24 sm:py-28">
      <div className="mx-auto max-w-3xl px-5">
        <SectionHeading eyebrow={c?.eyebrow} title={c?.title} subtitle={c?.subtitle} />
        <Reveal delay={0.15}>
          <Accordion type="single" collapsible className="mt-12 space-y-3">
            {(c?.items || []).map((item, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                data-testid={`faq-item-${i}`}
                className="overflow-hidden rounded-2xl border border-line bg-white px-6"
              >
                <AccordionTrigger className="py-5 text-right font-head text-base font-bold text-forest-950 hover:text-gold-dark hover:no-underline [&>svg]:text-gold-dark">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="pb-6 text-sm leading-relaxed text-moss">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
